/*
 * Shipping-waiver picker
 * ----------------------
 * Click handling for the three one-tap pieces rendered by snippets/free-ship-picker.liquid.
 *
 * This lives in its own asset, loaded from layout/theme.liquid, rather than inline in the
 * snippet. The snippet renders inside #CartDrawer, and the theme replaces that element's
 * innerHTML on every cart change — scripts injected that way never execute, so an inline
 * handler only bound on a full page load. The symptom was a dead button until the shopper
 * refreshed. Bound here once on document, it survives every re-render.
 */
(function () {
  if (window.__freeShipPickerBound) return;
  window.__freeShipPickerBound = true;

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-free-ship-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy) return;

    btn.dataset.busy = '1';
    var label = btn.textContent;
    btn.textContent = '…';

    try {
      var add = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.freeShipAdd), quantity: 1 }] })
      });
      if (!add.ok) throw new Error('add failed');

      // Re-render the drawer the same way the theme does, so the notice, the item list
      // and the totals all update together and the picker removes itself.
      var res = await fetch('/?sections=cart-drawer');
      var json = await res.json();
      var doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var current = document.querySelector('#CartDrawer');

      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        var overlay = current.querySelector('#CartDrawer-Overlay');
        var drawer = document.querySelector('cart-drawer');
        if (overlay && drawer) overlay.addEventListener('click', drawer.close.bind(drawer));
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      // Never leave the shopper with a dead button: fall back to the cart page.
      btn.textContent = label;
      delete btn.dataset.busy;
      window.location.href = '/cart';
    }
  });
})();


/*
 * Leo's Reward bar (21–23 Aug 2026)
 * ---------------------------------
 * The drawer renders the bar hidden. Only /cart.js reports a discount code that is on
 * the cart but not yet applicable — Liquid sees nothing until the $59 threshold is met,
 * which is the one moment the bar is pointless. So the reveal happens here.
 *
 * Lives in this asset, not inline in the snippet, because #CartDrawer is replaced via
 * innerHTML on every cart change and injected scripts never execute.
 */
(function () {
  if (window.__leoRewardBound) return;
  window.__leoRewardBound = true;

  var CODE = 'LEOREWARD20';
  var carries = null;

  async function reveal() {
    var bars = document.querySelectorAll('[data-leo-reward]');
    if (!bars.length) return;

    if (carries === null) {
      try {
        var cart = await (await fetch('/cart.js')).json();
        carries = (cart.discount_codes || []).some(function (d) {
          return (d.code || '').toUpperCase() === CODE;
        });
      } catch (e) {
        carries = false;
      }
    }
    if (!carries) return;
    bars.forEach(function (b) { b.hidden = false; });
  }

  // Re-check after every cart change, since the drawer is re-rendered wholesale.
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(reveal, 80); }

  document.addEventListener('cart:refresh', function () { carries = null; schedule(); });
  document.addEventListener('cart:refreshed', function () { carries = null; schedule(); });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
